import React,{
    createContext,
    useContext,
    useEffect,
    useState
} from 'react';

import pb from '../../lib/pb';

import { useAuth } from '../../contexts/AuthContext';

const BrandContext=createContext();

export function BrandProvider({
    children
}){

    const {user}=useAuth();

    const [brand,setBrand]=useState(null);

    const [draftBrand,setDraftBrand]=useState(null);

    const [loading,setLoading]=useState(true);

    const [error,setError]=useState(null);

    async function refreshBrand(){

        if(!user){

            setBrand(null);

            setDraftBrand(null);

            setError(null);

            setLoading(false);

            return;

        }

        try{

            setLoading(true);

            /* -------------------------
               Active Brand
            -------------------------- */

            try{

                const active=

                    await pb.collection('brands')
                    .getFirstListItem(
                        `owner="${user.id}" && status="active"`
                    );

                setBrand(active);

            }

            catch{

                setBrand(null);

            }

            /* -------------------------
               Draft Brand
            -------------------------- */

            try{

                const draft=

                    await pb.collection('brands')
                    .getFirstListItem(
                        `owner="${user.id}" && status="draft"`
                    );

                setDraftBrand(draft);

            }

            catch{

                setDraftBrand(null);

            }

            setError(null);

        }

        catch(err){

            setBrand(null);

            setDraftBrand(null);

            setError(err);

        }

        finally{

            setLoading(false);

        }

    }

    useEffect(()=>{

        refreshBrand();

    },[user]);

    useEffect(()=>{

        const id=brand?.id || draftBrand?.id;

        if(!id) return;

        pb.collection('brands')
        .subscribe(

            id,

            ()=>{

                refreshBrand();

            }

        );

        return ()=>{

            try{

                pb.collection('brands')
                .unsubscribe();

            }

            catch{}

        };

    },[brand,draftBrand]);

    async function createBrand(data){

        const record=

            await pb.collection('brands')
            .create({

                owner:user.id,

                status:"active",

                ...data

            });

        setBrand(record);

        return record;

    }

    async function updateBrand(data){

        const target=brand || draftBrand;

        if(!target) return;

        const updated=

            await pb.collection('brands')
            .update(

                target.id,

                data

            );

        if(updated.status==="draft"){

            setDraftBrand(updated);

        }

        else{

            setBrand(updated);

        }

        return updated;

    }

    return(

        <BrandContext.Provider

            value={{

                brand,

                draftBrand,

                loading,

                error,

                hasBrand:!!brand,

                refreshBrand,

                createBrand,

                updateBrand

            }}

        >

            {children}

        </BrandContext.Provider>

    );

}

export function useBrand(){

    return useContext(
        BrandContext
    );

}